module.exports = __webpack_public_path__ + "static/media/hosting3.5ca20823.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flat/hosting3.svg
// module id = 263
// module chunks = 0